import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import searchMediaContent, { generatePostData } from '@/utils/searchMediaLibrary';
import { getPathWithParams } from '@/utils/utils';

/**
 *
 * @param {object} searchOptions searchMediaContent options. See utils/searchMediaContent
 * @returns {[boolean, Array]} Search Results
 */
export default function useMediaListSearch(searchOptions) {
  const [results, setResults] = useState(/** @type {import("@/src/cms/components/types").MediaLibraryItem[]} */([]));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function mounted() {
      try {
        setLoading(true);
        const response = await searchMediaContent(searchOptions);
        setResults(response.results);
        setLoading(false);
      } catch (error) {
        setResults([]);
        setLoading(false);
      }
    })();
  }, []);

  return [loading, results];
}
